import React from 'react';
import { BaselineMastery } from './baselineMastery';
import { BaselineTeaching } from './baselineTeaching';
import { BaselineMaintenance } from './baselineMaintenance';

export const MasteryBox = ({ target }) => {
    return (
        <div className="full-width">
            <BaselineTeaching target={target} />
            <BaselineMastery target={target} />
            <BaselineMaintenance selectedTarget={target} />
        </div>
    );
};
